
define('text!modules/targeting/audience/templates/bin_title.html',[],function () { return '<div class="header-c title">{{bin_action}}d {{bin_label}}: <span class="count" data-bind="{{bin_action}}-count"></span><div class="icon-spinner"></div></div>';});

